import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const AlignJustify = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive({ textAlign: 'justify' }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<MenuOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().setTextAlign('justify').run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="ALIGN_JUSTIFY" defaultMessage="Justify" />
        </div>
      )}
    </Button>
  );
};

export default AlignJustify;
